import { casinos } from '../../mocks/casinos';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import CasinoCard from '../home/components/CasinoCard';
import { useState, useEffect } from 'react';

export default function RatingPage() {
  const [onlineCount, setOnlineCount] = useState(12847);

  useEffect(() => {
    const interval = setInterval(() => {
      setOnlineCount(prev => prev + Math.floor(Math.random() * 20) - 10);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in-up');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.animate-on-scroll').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0a0a0f] via-[#1a1a1f] to-[#0a0a0f] text-white">
      <Header onlineCount={onlineCount} />
      
      <section className="pt-32 pb-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16 animate-on-scroll opacity-0">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-[#d4af37] via-[#f4d03f] to-[#d4af37] bg-clip-text text-transparent">
              Полный рейтинг live-казино 2026
            </h1>
            <p className="text-lg md:text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
              Детальный обзор всех казино с живыми дилерами. Сравните условия, бонусы, 
              количество игр и выберите идеальную площадку для игры.
            </p>
          </div>

          {/* Filters */}
          <div className="mb-12 animate-on-scroll opacity-0">
            <div className="bg-[#242429] rounded-2xl p-6">
              <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
                <i className="ri-filter-3-line text-[#d4af37]"></i>
                Фильтры
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm text-gray-400 mb-2">Мин. ставка</label>
                  <select className="w-full bg-[#1a1a1f] border border-gray-700 rounded-xl px-4 py-2 text-white focus:border-[#d4af37] focus:outline-none cursor-pointer">
                    <option>Все</option>
                    <option>До 100₽</option>
                    <option>100-500₽</option>
                    <option>500₽+</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm text-gray-400 mb-2">Провайдер</label>
                  <select className="w-full bg-[#1a1a1f] border border-gray-700 rounded-xl px-4 py-2 text-white focus:border-[#d4af37] focus:outline-none cursor-pointer">
                    <option>Все</option>
                    <option>Evolution Gaming</option>
                    <option>Pragmatic Play Live</option>
                    <option>Ezugi</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm text-gray-400 mb-2">Язык дилеров</label>
                  <select className="w-full bg-[#1a1a1f] border border-gray-700 rounded-xl px-4 py-2 text-white focus:border-[#d4af37] focus:outline-none cursor-pointer">
                    <option>Все</option>
                    <option>Русский</option>
                    <option>Английский</option>
                    <option>Другие</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm text-gray-400 mb-2">Сортировка</label>
                  <select className="w-full bg-[#1a1a1f] border border-gray-700 rounded-xl px-4 py-2 text-white focus:border-[#d4af37] focus:outline-none cursor-pointer">
                    <option>По рейтингу</option>
                    <option>По количеству игр</option>
                    <option>По бонусам</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Casino Cards */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {casinos.map((casino, index) => (
              <div key={casino.id} className="animate-on-scroll opacity-0" style={{ animationDelay: `${index * 100}ms` }}>
                <CasinoCard casino={casino} />
              </div>
            ))}
          </div>

          {/* Additional Info */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-[#242429] rounded-2xl p-8 text-center animate-on-scroll opacity-0">
              <i className="ri-shield-check-line text-5xl text-[#2ecc71] mb-4 block"></i>
              <h3 className="text-xl font-bold mb-2">Проверенные казино</h3>
              <p className="text-gray-400">Все площадки имеют лицензии и проверены нашими экспертами</p>
            </div>
            <div className="bg-[#242429] rounded-2xl p-8 text-center animate-on-scroll opacity-0" style={{ animationDelay: '100ms' }}>
              <i className="ri-customer-service-2-line text-5xl text-[#d4af37] mb-4 block"></i>
              <h3 className="text-xl font-bold mb-2">Поддержка 24/7</h3>
              <p className="text-gray-400">Русскоязычная поддержка доступна круглосуточно</p>
            </div>
            <div className="bg-[#242429] rounded-2xl p-8 text-center animate-on-scroll opacity-0" style={{ animationDelay: '200ms' }}>
              <i className="ri-flashlight-line text-5xl text-[#f4d03f] mb-4 block"></i>
              <h3 className="text-xl font-bold mb-2">Быстрые выплаты</h3>
              <p className="text-gray-400">Вывод средств от 15 минут до 24 часов</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}